// extracted by mini-css-extract-plugin
export default {"wrapper":"Tooltip-module__wrapper___K9gZ2","sticky":"Tooltip-module__sticky___f83v+","arrow":"Tooltip-module__arrow___1jDJ0","arrowOnTop":"Tooltip-module__arrowOnTop___BT4xV"};